import React, { Component, Fragment } from 'react';
import { Table,Image } from "semantic-ui-react";
import {Button, Icon, Message, Modal, Form,Checkbox,Dropdown,TextArea, Radio, Segment} from "semantic-ui-react"
import { observer } from "mobx-react"
import { Link } from "react-router-dom"
import shop from "shop/shop"
import {Row, Col, FormField, FormInput} from "elemental-react16"
import _            from "lodash"
import productStore from "stores/productStore"
import ordinals from "theme/arnoldsports/sortParamsVariant"
import moment                               from "moment"
import Spinner                              from "components/Spinner/Spinner"
import SuccessTable                         from "components/Product/SuccessTableReturn"
import Responsive from "react-responsive"
import { data } from 'isotope-layout';
import categoryStore                                                                                 from "stores/categoryStore"
import queryString                                                                                   from "qs"
import cmsStore                                                                                      from "stores/cmsStore"
import ReturnPageProgress from './ReturnPageProgress';
import ProductListItem from "components/Product/ProductListItem"

let lastFilter = false


@observer
class ReturnPage extends Component {
    state = {
        seasonActive: true,
        product: null,
        returnActive: false,
        inventory: false,
        inventoryOrder: [],
        inventoryOrders: {},
        byId: {},
        loading: true,
        loadingSeason: false,
        showContact: false,
        loadingDelivery: false,
        notFoundPositions: [],
        showAdditionalArticle: false,
        newSeason: {
            season: {
                returnActive: false,
                seasonActive: false,
                bausteinSeason: "",
                bausteinValue: "",
                bausteinQuote: "",
                bausteinLieferwertUVP: "",
                bausteinUmsatzUVP: "",
                bausteinRetoureUVP: "",
            },
            seasons: {}
        }
    };

    async componentDidMount() {
        if (!shop.session) {
            console.log("!shop.session");
            this.props.history.push("/login");
            return;
        }
        //await this.handleLoadInventory();
        //await this.handleFetchDate();
        // await this.handleLoadDelivery();
        //await this.handleCheckForSeasonReturn();
        
        // Trigger handleChangeRadio with the default season name
        const defaultSeasonName = this.state.newSeason.season.name;
        if (defaultSeasonName) {
            //await this.handleChangeRadio(defaultSeasonName);
        }
        await this.handleFetchSaison();
        //this.handleCalculateDelivery();
        await this.load();
        //await this.handleLoadOrders();
        this.setState({ loading: false });
    }

        handleFetchSaison = async () => {
          console.log("DATA handleFetchSaison")
          try {
          const response = await shop.fetch('/shop/rest/config/?set=' + encodeURIComponent(JSON.stringify(["web.kv.id","web.kv.saison","web.kv.active","web.kv.year","web.kv.end"])), {
            method: 'GET',
            credentials: 'include'
          });
          console.log("DATA: ", response);
          const data = await response
          const active = data["web.kv.active"].split(",");
          const names = decodeURIComponent(data["web.kv.saison"]).split(",");
          let Ids = [];
          if (data["web.kv.id"]) {
            Ids = data["web.kv.id"].split(",");
          } else if (data["web.kv.saison"]) {
            const saison = decodeURIComponent(data["web.kv.saison"]);
            Ids = saison.split(",").map(s => (s.length >= 2 ? s[0] + s.slice(-2) : s));
          }
          let years = [];
          if (data["web.kv.year"]) {
            years = data["web.kv.year"].split(",");
          }
          let ends = [];
          if (data["web.kv.end"]) {
            ends = data["web.kv.end"].split(",");
          }
          console.log("DATA PARSED: ", names, active, Ids, years, ends);
          const seasons = {};
          for (let i = 0; i < names.length; i++) {
            if (active[i] !== "" && names[i] !== "") {
              seasons[names[i]] = {
            active: active[i],
            name: names[i],
            id: Ids[i] ? Ids[i] : "",
            year: years[i] ? years[i] : "",
            end: ends[i] ? ends[i] : "",
              };
            }
          }
          await this.setState({
            newSeason: {
              season: {
            active: "",
            name: "",
            id: "",
              },
              seasons: seasons
            }
          });
          console.log("DATA POST: ", this.state.newSeason);
          await this.setState({saved: true});
          } catch (error) {
          console.error('Error fetching saison:', error);
          }
        }

  load = ( props = this.props ) => {
    this.setState( { loading: true } )
    const query = queryString.parse( props.location.search.substr( 1 ) )
    const { categories = "" } = props.match.params
    const parentCategories = categories.split( "/" )
    console.log( "LOAD PRODUCTS WITH QUERY", query, parentCategories, this.state.newSeason.season.bausteinSeason )
    const categoryId = this.state.newSeason.season.bausteinSeason != "" ? this.state.newSeason.season.bausteinSeason : "Alle"
    const category = categoryStore.categoriesById.get( categoryId )
    
    // TODO: NOT EVERY CATEGORY STORE SUPPORTS THIS
    // categoryStore.fetchCategoryMeta && categoryStore.fetchCategoryMeta( categoryId )
    
    const { page = 1, count = shop.config.standards.ITEMS_PER_PAGE } = query
    let filters = []
    const fields = _.pick( query, shop.config.pickFilter )
    const filterSize = _.size( fields )
    
    _.forEach( fields, ( value, key ) => {
      
      // MULTIFILTERS ARE ADDED AS "OR"
      if ( Array.isArray( value ) ) {
        let queryFilters = value.map( v => {
          return {
            op: "equals", extra: true, field: key, value: v
          }
        } )
        
        let combinedFilter = { "or": queryFilters }
        filters.push( combinedFilter )
        
      } else {
        let filter = {
          op: "equals", extra: true, field: key, value: value
        }
        filters.push( filter )
      }
    } )
    
    // Only hide variants if we don't search by filter
    // i.e. user searches for color only available on variants
    if ( cmsStore.config.plugin.hideVariants ) {
      // FILTER ALL VARIANTS (ONLY MAIN-ARTCILES)
      let noVariants = {
        op: "equals", field: "type", value: "1"
      }
      const singleItems = { "field": "mainArticle", "op": "equals", "value": "" }
      let combinedFilter = [{ "or": [singleItems, noVariants] }]
      filters = filters.concat( combinedFilter ) // this shows only mainarticles (i.e. no-variants))
    }
    
    
    if ( categoryId ) {
      
      
      productStore.fromCategory( categoryId, {
        value: "%%",
        dir: query.dir || shop.config.standards.DIR || "des",
        sort: query.sort || shop.config.standards.SORT || "sort",
        page,
        count: count || shop.config.standards.ITEMS_PER_PAGE,
      }, filters ).then( res => {
        console.log( "NO PRODUCTS FOUND - FALLBACK TO 'SHOW ALL'", res )
        if ( !res.products.length ) {
          console.log( "NO PRODUCTS FOUND - FALLBACK TO 'SHOW ALL'" )
          let catQuery = {
            value: "%%",
            dir: query.dir || shop.config.standards.DIR || "des",
            sort: query.sort || shop.config.standards.SORT || "sort",
            page,
            count: count || shop.config.standards.ITEMS_PER_PAGE,
          }
          
          let additionalFilters = filters.filter( e => e.field !== "type" )
          
          // console.info( "NO VARIANTS FOUND - FALLBACK TO 'SHOW ALL'" )
          return productStore.fromCategory( categoryId, catQuery, additionalFilters )
                             .then( res => {
                               let { products } = res
                               if ( products.length === 0 ) {
                                 if ( products.length === 0 && shop.config.collections.showProductsFromSubCategories ) {
                                   // get products from all child categories
                
                                   const mapChildren = cat => {
                                     if ( cat.children.length > 0 ) return _.map( cat.children, mapChildren )
                                     return cat.map_id
                                   }
                
                                   const ids = _.flatten( category && category.children.map( mapChildren ) )
                                   if ( ids.length > 0 ) {
                                     return productStore.fromCategory( ids, catQuery, additionalFilters )
                                   }
                                 }
                               }
                               return res
                             } )
        }
        return res
      } )
                  .then( res => {
                    let { products, meta = {}, fields, size } = res
                    fields = fields || meta.fields
                   // console.log( "NEW FILTER FIELDS", categoryId, Object.keys( fields ).length, { fields } )
                    this.setState( { products, category, fields, size, meta, filterCount: fields && fields.length, loading: false } )
                    return res
                  } )
    } else {
      productStore.query( {
                            value: "%%",
                            filter: [...filters],
                            dir: query.dir || shop.config.filter_defaults.sort || "des",
                            sort: query.sort || shop.config.filter_defaults.sort,
                            page,
                            count: count || shop.config.standards.ITEMS_PER_PAGE,
                          } )
                  .then( res => {
                    lastFilter = this.props.location.search
                    let { products, size } = res
                    this.setState( { products, size, filterCount: fields && fields.length, loading: false } )
                  } )
    }
    
  }

    async loadProduct( id ) {
      if ( this.id === id ) return
      this.id = id
      productStore.get( id )
        .then( async product => {
          console.log( "ProductPage::product", product )
          await shop.cart.setExtra("preferredBaustein", true);
          if(product == false){
            console.log("NO PRODUCT FOUND FOR SELECTED SEASON")
            await shop.cart.setExtra("preferredBaustein", false);
          }
          product.count = 1
          await this.setState( {product: product } )
  
        } )
        .catch( error => {
          this.setState( {error} )
        } )
    }

     handleLoadOrders = async () => {
        let { orders, current } = this.state
        let pageSize = 10
        let start = 0
        current = current + pageSize
        this.setState( { loading: true } )
        
        await shop.fetch( `/shop/rest/data/orders?open=0&start=${start}&count=${pageSize}&status=%5B0%2C1%2C2%2C3%5D&filter=[{"field":"customerId","op":"equals","value":"${shop.session.value.map_id}"}]
          &extras=%7B"bausteinSeason":"${this.state.newSeason.season.bausteinSeason}"%7D` , {
                  method: "GET",
                  credentials: "include",
              })
          .then( async res => {
            console.log( "FROM API:::", { res } )

            await this.setState( { loading: false, current, orders, seasonActive: false } )
            
            if ( res.values.length === 0 ) {
            await this.setState( { noMoreOrders: true, current, orders, seasonActive: true } )
            }
          } )
      }




    handleChangeRadio = async (bausteinSeason, bausteinValue, bausteinYear) => {
    
    const tempValues = Object.keys(shop.session.value.extras)
        .filter(k => k.endsWith(bausteinSeason))
        .reduce((acc, key) => {
            acc[key] = shop.session.value.extras[key];
            console.log("ACC", acc);

            return acc;
        }, {});
        
        console.log("tempValues ???", tempValues);
        this.setState({ loadingSeason: true });
        await this.setState({ 
            newSeason: { 
                ...this.state.newSeason, 
                season: {
                    ...this.state.newSeason.season,
                    seasonActive: true,
                    bausteinSeason: bausteinSeason,
                    bausteinValue: bausteinValue,
                    bausteinQuote: tempValues[`quote${bausteinSeason}`],
                    bausteinLieferwertUVP: tempValues[`lieferwertUVP${bausteinSeason}`],
                    bausteinUmsatzUVP: tempValues[`umsatzUVP${bausteinSeason}`],
                    bausteinRetoureUVP: tempValues[`retoureUVP${bausteinSeason}`],
                }
            } 
        });
        await this.setState({ product: null });
        console.log("NEW SEASON SELECTED", this.state.newSeason, bausteinValue+bausteinSeason);
        this.handleLoadOrders();
        await this.loadProduct(bausteinValue+bausteinSeason);

        await shop.cart.setExtra("bausteinSeason", bausteinSeason);
        await shop.cart.setExtra("bausteinSeasonYear", bausteinYear ? bausteinYear : "");
        await shop.cart.setExtra("bausteinValue", bausteinValue)
        await shop.cart.setExtra("bausteinQuote", bausteinValue)
        await shop.cart.setExtra("bausteinLieferwertUVP", tempValues[`lieferwertUVP${bausteinSeason}`])
        await shop.cart.setExtra("bausteinUmsatzUVP", tempValues[`umsatzUVP${bausteinSeason}`])
        await shop.cart.setExtra("bausteinRetoureUVP", tempValues[`retoureUVP${bausteinSeason}`])
        await shop.cart.setExtra("seasonActive", this.state.seasonActive)
        await shop.cart.postCart("cart" , {"positions": []})
        this.setState({ loadingSeason: false });
        console.log("ALREADY ORDERED IN THIS SEASON: ", this.state.seasonActive)
        this.setState({ showAdditionalArticle: true });
    }

    render() {
        const { loadingSeason, products, orders, product, showAdditionalArticle } = this.state;
        //console.log("DATA this.state",this.state.loading)
        console.log("DATA this.state product", products, orders)
        console.log("customerData", shop.session.value)
        if(this.state.loading){
            return (
                <div className="pa4 tc">
                    <Spinner size="md" type="inverted"/>
                </div>
            )
        }

        if(!shop.session){
            console.log("!shop.session")
            this.props.history.push("/login")
            document.location.reload()
            return null
        }
        let {  categoryId = "" } = this.props

        const bausteinWeihnachten = this.state.newSeason && this.state.newSeason.seasons["Weihnachten"] && this.state.newSeason.seasons["Weihnachten"].active && this.state.newSeason.seasons["Weihnachten"].active == "true" ? true : false;
        const bausteinOstern = this.state.newSeason && this.state.newSeason.seasons["Ostern"] && this.state.newSeason.seasons["Ostern"].active && this.state.newSeason.seasons["Ostern"].active == "true" ? true : false;
        const bausteinHerbst = this.state.newSeason && this.state.newSeason.seasons["Herbst"] && this.state.newSeason.seasons["Herbst"].active && this.state.newSeason.seasons["Herbst"].active == "true" ? true : false;
        
        const selectedSeasonName = this.state.newSeason.season.bausteinSeason;
        const selectedSeasonData = selectedSeasonName ? this.state.newSeason.seasons[selectedSeasonName] : null;
        const seasonExpired = selectedSeasonData && selectedSeasonData.end
          ? moment(selectedSeasonData.end, 'DD.MM.YYYY').isBefore(moment(), 'day')
          : false;
        console.log("WEIHNACHTEN CHECKED: ", selectedSeasonName, bausteinWeihnachten, selectedSeasonData, seasonExpired)
        return (
            <Fragment>
            <section className="container pt2 pb2">
                <ReturnPageProgress progress={0} />
            </section>
            <Responsive minWidth={790} >
            <section className="relative">
            <div className="absolute top-1 right-1">

            </div>
            <Row>
            <Col className="tc pb4"
             style={{marginTop: "71px"}}>
            <a className={"logo"} href="">
            <img
            src={shop.config.logo}
            alt="" />
            </a>
            </Col>
            </Row>
            </section>
            <section className="container pb4" style={{width:"50%"}}>
            {/* <Message className="f2 fw7">
            {translate( " this.state.newSeason.season.returnActive && Ihre Bestellung ist bei uns eingegangen und wird schnellstmöglich bearbeitet. Bei Änderungen / Fragestellungen melden Sie sich bitte bei der Ihnen bekannten Kontaktperson im Vertriebsinnendienst")}
            </Message>*/}
            {console.log("SEASON ACTIVE", this.state.seasonActive)}
            {!this.state.seasonActive && <Message className="f2 fw7"  style={{borderRadius: "25px"}} negative>
            {translate( `Sie haben für diese Saison bereits eine Bestellung getätigt. Bitte wenden Sie sich an Ihren Ansprechpartner oder wählen Sie eine andere Saison.`)}
            </Message>}
                    {seasonExpired && this.state.newSeason.season.bausteinSeason && 
                      <Message negative className="f2 fw7" style={{borderRadius: "25px"}}>
            Der Bestellzeitraum für diese Saison ist abgelaufen. Eine Bestellung ist nicht mehr möglich.
          </Message>}
            <div>
            
            <Table className="pl4 pr3"  style={{borderRadius: "25px"}} >
            <colgroup>
            </colgroup>
            <thead>
            </thead>
            <tbody>
            <tr>
            <h1 style={{color:"#265a88"}}  className="pt4 tl"><b>{translate("Displayshop Online ")}</b></h1><br/>
            <p className=""><b>Herzlich willkommen bei der Deco-Bestellung der Brauns-Heitmann GmbH.</b></p>
            <p className="pb2">Sie sind angemeldet als: </p>
            </tr>
            <tr>
            <td>
            <Table className="TableCustDataReturnPage">
            <colgroup>
            <col width="50%" />
            <col width="25%" />
            </colgroup>
            <thead>
            <tr>
            </tr>
            </thead>
            <tbody>
            <tr>
            <td style={{fontSize:15}}><b>GLN / ILN:</b>
            </td> 
            <td>{shop.session.value.map_id}
            </td> 
            </tr>
            <tr>
            <td style={{fontSize:15, alignContent:"top"}}><b >Filiale:</b><br/><br/><br/>
            </td> 
            <td><strong>{shop.session.value.title}</strong><br/>
            {shop.session.value.street}<br/>
            {shop.session.value.pcode + " " + shop.session.value.city}<br/>
            {shop.session.value.country}
            </td> 
            </tr>

            <tr style={{border: "3px solid red"}} >
            <td style={{fontSize:15, alignContent:"top"}}><b >Saisonauswahl:</b><br/><br/><br/>
            </td> 
            <td style={{fontSize:18, fontWeight: "bold"}}>
            <Form>{/*.filter(key => {
                if(key == "bausteinWeihnachten" && bausteinWeihnachten == false){
                  return false
                }
                if(key == "bausteinOstern" && bausteinOstern == false){
                  return false
                }
                if(key == "bausteinHerbst" && bausteinHerbst == false){
                  return false
                }
                return key.startsWith('baustein')
              }) */}
            {Object.values(this.state.newSeason.seasons)
              .filter(season => season.active === "true")
              .map((season) => (
            <div key={season.name}>
            <FormField>
            <Radio
            id={'baustein' + season.name}
            name="season"
            label={season.year ? `${season.name} ${season.year}` : season.name}
            checked={this.state.newSeason.season.bausteinSeason === season.name}
            onChange={() => this.handleChangeRadio(season.name, shop.session.value.extras['baustein' + season.name], season.year)}
            />
            </FormField>
            </div>
            ))}
            </Form>

            
            </td> 
            </tr>

            {!seasonExpired && <tr style={{border: "none"}} >
            {this.state.newSeason.season && this.state.newSeason.season.bausteinSeason && <td colSpan={2}>
              <p className="fw7 f5"> {translate("Ihre Daten der Vorjahressaison")}: </p>
                <div className="saisonAuswahl">{/*console.log("SHOW SEASON DATA", (Number(this.state.newSeason.season[`bausteinLieferwertUVP`].substring(0, this.state.newSeason.season[`bausteinLieferwertUVP`].length-2).replaceAll(".", "").replaceAll(",", ".")) + Number(this.state.newSeason.season[`bausteinRetoureUVP`].substring(0, this.state.newSeason.season[`bausteinRetoureUVP`].length-2).replaceAll(".", "").replaceAll(",", "."))).toFixed(2).toString().replace(".", ",").replace(/\B(?=(\d{3})+(?!\d))/g, "."))*/}
                    <div className="saisonAuswahlZeile"><div className="pa2 fw6 f5">{translate("Ausgewählte Saison: ")}</div><div className="pa2">{this.state.newSeason.season.bausteinSeason}</div> </div>
                    <div className="saisonAuswahlZeile"><div className="pa2 fw6 f5">{translate("Lieferwert UVP Vorjahr: ")}</div><div className="pa2">{this.state.newSeason.season[`bausteinLieferwertUVP`]}</div> </div>
                    <div className="saisonAuswahlZeile"><div className="pa2 fw6 f5">{translate("Effektiver UVP-Umsatz Vorjahr: ")}</div><div className="pa2">{this.state.newSeason.season[`bausteinLieferwertUVP`] && this.state.newSeason.season[`bausteinRetoureUVP`] ? this.state.newSeason.season[`bausteinRetoureUVP`] : ""}</div> </div>
                    <div className="saisonAuswahlZeile"><div className="pa2 fw6 f5">{translate("Retourenquote Vorjahr: ")}</div><div className="pa2">{this.state.newSeason.season[`bausteinQuote`]}</div> </div>
                </div>
                </td>}
            </tr>}
            {!seasonExpired && product != null &&<tr>
            <td colSpan={2}>
              <p className="fw7 f5"> {translate("Aufgrund der Vorjahreswerte empfehlen wir folgenden Baustein")}: </p>
              <div className="saisonAuswahl">

                { <ProductListItem
                                  history={this.props.history}
                                  place={this.state.seasonActive ? "returnEmpfehlung" : "return"}
                                  index={0}
                                  key={product.map_id}
                                  product={product}
                                  /> }
                                  </div>
              </td>
            </tr>}
            {this.state.seasonActive && !seasonExpired && showAdditionalArticle && <tr>
            <td colSpan={2}>
              <p className="f5 fw6">{translate("Falls Sie keine von uns ausgewählten Bausteine benötigen:")}</p>
              <div className="additionalArticle">
                <p className="f4 fw6">{translate("Ich möchte lediglich zusätzliche Sortimente bestellen.")}</p>
                                                  <Link to="/return/quantityAddons/"><Button primary style={{ borderRadius: "25px", height: "50px", width: "350px"	}} onClick={() => this.setState({ product: null })}>
                        {translate( "Hier klicken") }
                        <i className="icon-angle-right"/>
                        </Button></Link>
                                  </div>

              </td>
            </tr>}
            <tr>
                <td colSpan={2}>
                <div className="flex flex-row justify-between pt3">
                    <div>
                        <Link to={{
                        pathname: `/logout`,
                        search  : this.props.location.search
                        }}>
                        <Button  style={{ borderRadius: "25px", height: "50px"	}}>
                        {translate( "Zurück zur Anmeldung" )}
                        <i className="icon-angle-right"/>
                        </Button>
                        </Link>
                    </div>
                    <div>
                      {console.log("SHOW BUTTON", this.state.newSeason.season, this.state.newSeason.season.bausteinSeason, this.state.seasonActive)}
                        {this.state.newSeason.season.bausteinSeason && this.state.seasonActive && !seasonExpired && <Link to={{
                        pathname: `/return/quantity`,
                        search  : this.props.location.search
                        }}>
                        <Button  style={{width:"200px", borderRadius: "25px", height: "50px"}}>
                        {product != null ? translate( "Abweichende Bausteine" ) : translate("Zu den Bausteinen")}
                        <i className="icon-angle-right"/>
                        </Button>
                        </Link>}
                    </div>
                </div>
                </td>
            </tr>
            </tbody>
            </Table>
            </td>
            </tr>
            <tr>
            <br/>
            </tr>
            <tr>
            <td>

            </td>
            </tr>
            </tbody>
            </Table>
            </div>

            {/*            <div className="saisonAuswahl">
            <div>Saisonauswahl:</div>
            <div> <Dropdown clearable options={0} selection/> </div>
            </div> */}

            </section>
            </Responsive>
            <Responsive maxWidth={789} >
            <section>
            <Row>
            <Col className="tc pb2 pt1">
            <a className={"logo"} href="">
            <img
            src={shop.config.logo}
            alt="" />
            </a>
            </Col>
            </Row>
            </section>
            {!this.state.seasonActive && <Message style={{borderRadius: "25px"}} className="f2 fw7" negative>
            {translate( `Sie haben für diese Saison bereits eine Bestellung getätigt. Bitte wenden Sie sich an Ihren Ansprechpartner oder wählen Sie eine andere Saison.`)}
            </Message>}
            {seasonExpired && this.state.newSeason.season.bausteinSeason && 
              <Message negative style={{borderRadius: "25px"}}>
                Der Bestellzeitraum für diese Saison ist abgelaufen. Eine Bestellung ist nicht mehr möglich.
            </Message>}
            <div className="pa3"  style={{borderRadius: "25px"}} >
            <table className="pl3 pr3">
            <colgroup>
            <col width="100%" />
            </colgroup>
            <tbody>
            <tr className="tc bb b--black-20 bt">
            <td>
            <h1 style={{color:"#265a88"}}  className="pt4 tc"><b>{translate("Displayshop Online")}</b></h1><br/>
            <p className="tc"><b>Herzlich willkommen bei der Deco-Bestellung der Brauns-Heitmann GmbH.</b></p>
            <p className="tc pb2">Sie sind angemeldet als: </p>

            </td>
            </tr>
            <tr className="pa2 bb b--black-20">
            
            <td>
            <table>
            <colgroup>
            <col width="25%" />
            <col width="75%" />
            </colgroup>
            <tbody>
            <tr className="bb b--black-10">
            <td style={{fontSize:15}}><b>GLN / ILN:</b>
            </td> 
            <td>{shop.session.value.map_id}
            </td> 
            </tr>
            <tr>
            <td style={{fontSize:15, alignContent:"top"}}><b >Filiale:</b><br/><br/><br/>
            </td> 
            <td><strong>{shop.session.value.title}</strong><br/>
            {shop.session.value.street}<br/>
            {shop.session.value.pcode + " " + shop.session.value.city}<br/>
            {shop.session.value.country}
            </td> 
            </tr>
            <tr>
            <td style={{fontSize:15, alignContent:"top"}}><b >Saisonauswahl:</b><br/><br/><br/>
            </td> 
            <td style={{fontSize:15, fontWeight: "bold"}}>
            <Form>
            {Object.values(this.state.newSeason.seasons)
              .filter(season => season.active === "true")
              .map((season) => (
            <div key={season.name}>
            <FormField>
            <Radio
            id={'baustein' + season.name}
            name="season"
            label={season.year ? `${season.name} ${season.year}` : season.name}
            checked={this.state.newSeason.season.bausteinSeason === season.name}
            onChange={() => this.handleChangeRadio(season.name, shop.session.value.extras['baustein' + season.name])}
            />
            </FormField>
            </div>
            ))}
            </Form>

            
            </td> 
            </tr>

            {!seasonExpired && <tr>
            {this.state.newSeason.season && this.state.newSeason.season.bausteinSeason && <td colSpan={2}>
                <div className="saisonAuswahl">
                    <div className="saisonAuswahlZeile"><div className="pa2 fw6 f5">{translate("Ausgewählte Saison: ")}</div><div className="pa2">{this.state.newSeason.season.bausteinSeason}</div> </div>
                    <div className="saisonAuswahlZeile"><div className="pa2 fw6 f5">{translate("Lieferwert UVP Vorjahr: ")}</div><div className="pa2">{this.state.newSeason.season[`bausteinLieferwertUVP`]}</div> </div>
                    <div className="saisonAuswahlZeile"><div className="pa2 fw6 f5">{translate("Effektiver UVP-Umsatz Vorjahr: ")}</div><div className="pa2">{this.state.newSeason.season[`bausteinLieferwertUVP`] && this.state.newSeason.season[`bausteinRetoureUVP`] ? (Number(this.state.newSeason.season[`bausteinLieferwertUVP`].substring(0, this.state.newSeason.season[`bausteinLieferwertUVP`].length-2).replaceAll(".", "").replaceAll(",", ".")) + Number(this.state.newSeason.season[`bausteinRetoureUVP`].substring(0, this.state.newSeason.season[`bausteinRetoureUVP`].length-2).replaceAll(".", "").replaceAll(",", "."))).toFixed(2).toString().replace(".", ",").replace(/\B(?=(\d{3})+(?!\d))/g, ".") + " €" : ""}</div> </div>
                    <div className="saisonAuswahlZeile"><div className="pa2 fw6 f5">{translate("Retourenquote Vorjahr: ")}</div><div className="pa2">{this.state.newSeason.season[`bausteinQuote`]}</div> </div>
                </div>
                </td>}
            </tr>}
            {!seasonExpired && product != null &&<tr>
            <td colSpan={2}>
              <div className="saisonAuswahl">
                { <ProductListItem
                                  history={this.props.history}
                                  place={this.state.seasonActive ? "returnEmpfehlung" : "return"}
                                  index={0}
                                  key={product.map_id}
                                  product={product}
                                  /> }
                                  </div>
              </td>
            </tr>}
            </tbody>
            </table>
            
            </td>
            <td>&nbsp;</td>
            </tr>
            <tr>
            <td>
            <div className="pb2 tc">
            </div>
            </td>
            </tr>
            </tbody>

            </table>
            <table>
            <colgroup>
            <col width="50%" />
            <col width="50%" />
            </colgroup>
            <tbody>
            <tr className="tc">
            <td className="tc">
            <Link to={{
            pathname: `/logout`,
            search  : this.props.location.search
            }}>
            <Button style={{maxWidth:"160px", borderRadius: "25px", height: "50px"}}>
            {translate( "Zurück zur Anmeldung" )}
            <i className="icon-angle-right"/>
            </Button>
            </Link>
            </td>
            <td className="tc">
            {this.state.newSeason.season.bausteinSeason && this.state.seasonActive && !seasonExpired && <Link to={{
            pathname: `/return/quantity`,
            search  : this.props.location.search
            }}>
            <Button style={{ maxWidth:"160px", borderRadius: "25px", height: "50px"}} disabled={loadingSeason}
            onClick={async () => {
            const checkSeasonName = await shop.cart.getExtra("seasonName")
            if(checkSeasonName == ""){
                console.log("CHECK SEASON NAME", checkSeasonName)
                await shop.cart.setExtra("seasonName", this.state.newSeason.season.name)
                await shop.cart.setExtra("seasonID", this.state.newSeason.season.id)
            }
            }}
             >
            {product != null ? translate( "Abweichende Bausteine" ) : translate("Zu den Bausteinen")}
            <i className="icon-angle-right"/>
            </Button>
            </Link>}
            </td>
            </tr>
            </tbody>
            </table>
            </div>
            </Responsive>
            </Fragment>
        );
    }
}

export default ReturnPage;


// WEBPACK FOOTER //
// ./src/theme/braunsheitmannShop/pages/returnCheckout/ReturnPage.js